export const SERVICE_MEDIA = {
  dashboard: '/dashboard.png',
  jig: '/jig.png',
  panel: '/panel.png',
};


